@if (authenticated() && isDataLoaded()) {
    <app-block-ui />
    <div class="min-h-full">
        <app-header
            [user]="user()()"
            [userRoles]="userRoles()()"
            [options]="menu()()"
            [userOptions]="userMenu()()"
            [city]="city()"
            (logoutEvent)="logout()"
            (cityChange)="changeCity($event)"
        />

        <main class="mx-auto p-6 pt-4 md:pb-0">
            <div class="grid grid-cols-1">
                <main>
                    <router-outlet></router-outlet>
                </main>
            </div>
        </main>
    </div>
    <p-toast />
}
